import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import api from "APP_ROOT/api";
import { dollars } from "LIB/formatters/currency";
import { DataTable } from "MODULES/shared/components";
import SimpleDateRangePicker from "MODULES/shared/components/SimpleDateRangePicker/SimpleDateRangePicker";
import { API_BASE, MONTH } from "APP_ROOT/constants";
import LocationsDropDown from "MODULES/Locations/components/LocationsDropDown";
import moment from "moment";
import MonthlyStats from "./MonthlyStats";
import HeaderStats from "./HeaderStats";

function renderRow(r) {
  return (
    <tr key={r.buyer}>
      <td>{r.buyer}</td>
      <td className="text-right">{dollars(r.total_depreciations)}</td>
    </tr>
  );
}

export class Table extends Component {
  constructor() {
    super();
    this.fetchMonthResults = this.fetchMonthResults.bind(this);
    this.fetchTodaysResults = this.fetchTodaysResults.bind(this);
    this.state = {
      endDate: moment().endOf(MONTH),
      monthResults: [],
      todaysResults: [],
      monthlyDataLoading: false,
      startDate: moment().startOf(MONTH)
    };
  }

  componentDidMount() {
    this.fetchTodaysResults();
    this.fetchMonthResults();
  }

  getWriteDownSum = (monthResults, key) => (
    <td className="text-right">
      {dollars(
        monthResults.reduce(
          (sum, result) => sum + result[`${key}_write_downs`],
          0
        )
      )}
    </td>
  );

  handleDateChange = (startDate, endDate) => {
    this.setState({
      monthlyDataLoading: true,
      startDate,
      endDate
    });

    if (startDate) {
      this.fetchMonthResults(startDate);
    } else {
      this.setState({
        monthResults: [],
        monthlyDataLoading: false
      });
    }
  };

  handleLocationChange = locationId => {
    this.setState({
      monthlyDataLoading: true,
      locationId
    });

    this.fetchMonthResults(this.state.selectedDate, locationId);
  };

  fetchTodaysResults() {
    const { endDate, startDate } = this.state;

    api.reports.depreciations
      .searchPerLocation(startDate, endDate)
      .then(res => {
        this.setState({
          todaysResults: res.data,
          monthlyDataLoading: false
        });
      });
  }

  fetchMonthResults() {
    const { endDate, startDate, locationId } = this.state;

    Promise.all([
      api.reports.depreciations.search(startDate, endDate, locationId),
      api.reports.depreciations.searchPerLocation(startDate, endDate)
    ]).then(([res, perLocation]) => {
      const results = res.data.results.filter(
        x =>
          Math.abs(x.total_depreciations) !== 0 ||
          Math.abs(x.total_write_downs) !== 0
      );

      this.setState({
        monthResults: Object.assign(results, {
          perLocation: perLocation.data
        }),
        monthlyDataLoading: false
      });
    });
  }

  reportStartTime(selectedDate) {
    return moment(selectedDate || this.state.selectedDate)
      .startOf("month")
      .format();
  }

  reportEndTime(selectedDate) {
    return (this.reportStartTime(selectedDate)
      ? moment(this.reportStartTime(selectedDate))
      : moment()
    )
      .endOf("month")
      .format();
  }

  render() {
    const {
      endDate,
      todaysResults,
      monthResults,
      monthlyDataLoading,
      startDate
    } = this.state;

    return (
      <React.Fragment>
        <HeaderStats
          depreciationsData={todaysResults}
          refresh={this.fetchTodaysResults}
        />
        <Row>
          <Col>
            <div
              className="page-header monthly-depreciations-header"
              style={{ padding: "10px, 30px" }}
            >
              <h1 style={{ marginTop: "7px" }}>
                <span className="header-content depreciations-header">
                  <span
                    style={{
                      marginTop: "8px",
                      marginRight: "10px",
                      verticalAlign: "super",
                      display: "flex"
                    }}
                  >
                    <span>
                      {startDate &&
                        `${moment(startDate).format("MMMM DD YYYY")}`}
                      {endDate && `- ${moment(endDate).format("MMMM DD YYYY")}`}
                    </span>
                    <div style={{ marginLeft: "8px" }}>
                      <LocationsDropDown
                        handleChange={this.handleLocationChange}
                      />
                    </div>
                  </span>
                  <div style={{ display: "inline-block" }}>
                    <SimpleDateRangePicker
                      handleDateChange={this.handleDateChange}
                    />
                    {monthResults.length > 0 && (
                      <a
                        href={`${API_BASE}/monthly_depreciations/download.xls?start_time=${this.reportStartTime(
                          startDate
                        )}&end_time=${this.reportEndTime(
                          endDate
                        )}&location_id=${this.state.locationId || ""}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button
                          className={`btn btn-primary btn-hollow pull-right`}
                          type="button"
                        >
                          <i className="fa fa-lg fa-cloud-download" />
                          &nbsp;&nbsp;Download Report
                        </button>
                      </a>
                    )}
                  </div>
                </span>
              </h1>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <DataTable loading={monthlyDataLoading} loadingRows={40}>
              <DataTable.Head>
                <th>Name</th>
                <th className="text-right">Total Depreciations</th>
              </DataTable.Head>
              <DataTable.Body>
                {monthResults.map(r => renderRow(r))}
                <tr key="probono">
                  <td>Pro Bono</td>
                  {this.getWriteDownSum(monthResults, "total")}
                </tr>
              </DataTable.Body>
            </DataTable>
          </Col>
        </Row>
        {monthResults.length > 0 && (
          <MonthlyStats
            selectedDate={startDate}
            depreciationsData={monthResults}
            refresh={this.fetchMonthResults}
          />
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/DepreciationsDashboard/Components/Table.jsx